export const contactsData = {
    email: 'sabhishek647@gmail.com',
    phone: '+91-9898689859',
    address: 'Ankleshwar, Bharuch, Gujarat',

    sheetAPI: ''
}